class StockistList extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.activeBlock = null;
    this.activeLabel = null;
    this.instructions = this.querySelector('stockist-instructions');
    this.toggle = this.querySelector('stockist-toggle');
    const controls = this.querySelectorAll('.label-control');
    controls.forEach(i => {
      i.addEventListener('click', () => {
        const list = this.querySelector(`ul[data-area="${i.dataset.area}"]`);
        list.dataset.state !== 'open' 
          ? list.setAttribute('data-state', 'open')
          : list.setAttribute('data-state', 'closed');
      })
    })
  }

  select(stockistId) {
    if(this.instructions.dataset.state === 'active') {
      this.instructions.setAttribute('data-state', 'hidden');
    }
    if(this.activeBlock) {
      this.activeBlock.hide();
    }
    if(this.activeLabel) {
      this.activeLabel.inactive();
    }
    this.activeBlock = this.querySelector(`stockist-block[data-id="${stockistId}"]`);
    this.activeLabel = this.querySelector(`stockist-label[data-id="${stockistId}"]`);
    this.activeBlock.show();
    this.activeLabel.active();
    this.toggle.close();
  }
}

class StockistLabel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.parent = this.closest('stockist-list');
    this.addEventListener('click', () => this.parent.select(this.stockistId))
  }

  get stockistId() {
    return this.dataset.id;
  }

  get state() {
    return this.dataset.state;
  }

  set state(state) {
    this.setAttribute('data-state', state);
  }

  active() {
    this.state = 'active';
  }

  inactive() {
    this.state = 'inactive';
  }
}

class StockistBlock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.parent = this.closest('stockist-list');
  }

  get state() {
    return this.dataset.state;
  }

  set state(state) {
    this.setAttribute('data-state', state);
  }

  show() {
    this.state = 'active';
    this.scrollIntoView()
  }

  hide() {
    this.state = 'hidden';
  }
}

class StockistToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.parent = this.closest('stockist-list');
    this.nav = this.parent.querySelector('nav');
    this.addEventListener('click', this.toggle)
  }

  toggle() {
    this.nav.dataset.state !== 'open'
      ? this.open()
      : this.close();
  }

  open() {
    this.nav.setAttribute('data-state', 'open');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.nav.setAttribute('data-state', 'closed');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.get('stockist-list') || customElements.define('stockist-list', StockistList);
customElements.get('stockist-label') || customElements.define('stockist-label', StockistLabel);
customElements.get('stockist-block') || customElements.define('stockist-block', StockistBlock);
customElements.get('stockist-toggle') || customElements.define('stockist-toggle', StockistToggle);